/**
 * `/profile` — the owner view.
 *
 * One `RouteObject`, so the file is `.route.tsx` (singular). The route
 * resolves nothing and fetches nothing: no `loader` in this repo performs a
 * data read, because a fetching loader would create a cache TanStack Query
 * does not know about and the two would drift on every mutation.
 *
 * The chunk splits through the router's OWN `lazy` rather than `React.lazy`:
 * the data router awaits it before rendering the match, so the feature needs
 * no `Suspense` boundary of its own.
 */
import type { RouteObject } from 'react-router-dom';

export const profileMeRoute: RouteObject = {
  path: 'profile',
  lazy: async () => {
    const { ProfileMePage } = await import('./ProfileMe');
    return { Component: ProfileMePage };
  },
};
